// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vZVOhL7UMpFjIw3Zbar0 {
  position: relative;
}

.K0jx83cMMqOLnMXTcL9I {
  height: 8px;
  display: flex;
  gap: 4px;
  width: 100%;
}

.e618cTmHIr5l5PNkkMDm {
  flex: 1;
  position: relative;
  background-color: var(--grey-gradient-start-color-10);
  border: 1px solid var(--grey-color-60);
  border-radius: 24px;
  overflow: hidden;
}

.p87_YS9WveIm8PZXKL6v {
  height: 100%;
  background-color: var(--grey-color-60);
  border-radius: 24px;
}

.u2QU2OIuIKo2Hol1XFaY {
  top: 50%;
  height: 20px;
  min-width: 38px;
  border: 1px solid var(--grey-color-60);
  border-radius: 54px;
  color: var(--grey-color-90);
  padding: 0 6px 0;
  background-color: var(--grey-gradient-start-color-10);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  white-space: nowrap;
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/components/HoganAverageScore/HoganAverageScore.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;AACF;;AAEA;EACE,OAAA;EACA,kBAAA;EACA,qDAAA;EACA,sCAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,sCAAA;EACA,mBAAA;AACF;;AAEA;EACE,QAAA;EACA,YAAA;EACA,eAAA;EACA,sCAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,qDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AACF","sourcesContent":[".hoganAverageMainContainer {\n  position: relative;\n}\n\n.hoganAverageContainer {\n  height: 8px;\n  display: flex;\n  gap: 4px;\n  width: 100%;\n}\n\n.averageScoreSteps {\n  flex: 1;\n  position: relative;\n  background-color: var(--grey-gradient-start-color-10);\n  border: 1px solid var(--grey-color-60);\n  border-radius: 24px;\n  overflow: hidden;\n}\n\n.averageScoreFill {\n  height: 100%;\n  background-color: var(--grey-color-60);\n  border-radius: 24px;\n}\n\n.averageBubble {\n  top: 50%;\n  height: 20px;\n  min-width: 38px;\n  border: 1px solid var(--grey-color-60);\n  border-radius: 54px;\n  color: var(--grey-color-90);\n  padding: 0 6px 0;\n  background-color: var(--grey-gradient-start-color-10);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  white-space: nowrap;\n  z-index: 10;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hoganAverageMainContainer": `vZVOhL7UMpFjIw3Zbar0`,
	"hoganAverageContainer": `K0jx83cMMqOLnMXTcL9I`,
	"averageScoreSteps": `e618cTmHIr5l5PNkkMDm`,
	"averageScoreFill": `p87_YS9WveIm8PZXKL6v`,
	"averageBubble": `u2QU2OIuIKo2Hol1XFaY`
};
export default ___CSS_LOADER_EXPORT___;
